import axios from 'axios';
import { getConfig } from './runtimeConfig';

// Use runtime config api_base ("/api") — no hardcoded domains
function getApiBase() {
  const cfg = getConfig();
  return cfg.api_base || '/api';
}

export const API = getApiBase();

// Axios instance with credentials
export const apiClient = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
apiClient.interceptors.request.use((config) => {
  // Ensure baseURL is always from runtime config
  config.baseURL = getApiBase();
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 — expired session (token_version mismatch) → redirect to login
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && error.response?.data?.detail?.includes('Session expired')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login?reason=session_expired';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
